import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6StaticDatumsEdit } from "./edit";
import { A6StaticDataNew } from "./new";
import { A6StaticDatumsTable } from "./table";
export default function A6StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6StaticDatumsEdit />} />
      <Route index element={<A6StaticDatumsTable />} />
      <Route path="/new" element={<A6StaticDataNew />} />
    </Routes>
  );
}
